import {
  Button,
  Popover,
  PopoverContent,
  PopoverDescription,
  PopoverHeader,
  PopoverTitle,
  PopoverTrigger,
} from '@repo/shared-client/components/ui'
import { cn } from '@repo/shared-client/lib/utils'
import { CircleHelpIcon } from 'lucide-react'
import type { ComponentProps, ReactNode } from 'react'

interface SFInfoPopupProps {
  title: string
  description: string
  icon?: ReactNode
  trigger?: ReactNode
  iconButtonProps?: ComponentProps<typeof Button>
}

const SFInfoPopup = ({ title, description, icon, trigger, iconButtonProps }: SFInfoPopupProps) => {
  const hasTextTrigger = trigger != null

  return (
    <Popover>
      <PopoverTrigger
        render={
          <Button
            size={hasTextTrigger ? 'xs' : 'icon-sm'}
            type="button"
            variant="ghost"
            {...iconButtonProps}
            aria-label={iconButtonProps?.['aria-label'] ?? title}
            className={cn(
              hasTextTrigger
                ? 'ml-auto h-auto min-h-0 rounded-md px-0 font-normal text-muted-foreground text-xs hover:bg-transparent hover:text-foreground hover:underline'
                : 'rounded-full',
              iconButtonProps?.className
            )}
          />
        }
      >
        {trigger ?? icon ?? <CircleHelpIcon aria-hidden className="size-5" />}
      </PopoverTrigger>
      <PopoverContent
        align="center"
        className="w-72 gap-0 p-4"
        positionerClassName="shadcn-light-scope"
        side="bottom"
        sideOffset={4}
      >
        <PopoverHeader className="gap-2">
          <PopoverTitle>{title}</PopoverTitle>
          <PopoverDescription className="text-sm">{description}</PopoverDescription>
        </PopoverHeader>
      </PopoverContent>
    </Popover>
  )
}

export default SFInfoPopup
